// import { useQuery } from "react-query";
// import { getUniversities } from "../services/school/university/university";
// import { Key_universities } from "../utils/constants";
// import { PagedRequestType } from "../types/PagedResults";

// export const useGetUniversitiesQuery = (data: PagedRequestType) => {
//     return useQuery([Key_universities,  JSON.stringify(data)], () => getUniversities(data));
// };


import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { PagedRequestType } from "../types/PagedResults";
import { getUniversities, getUniversitiesByIdFaculties } from "../services/school/university/university";
import { RootState } from "../redux/store";
import { Key_universities } from "../utils/constants";

export const useGetUniversitiesQuery = (data: PagedRequestType) => {
  const managerData = useSelector((state: RootState) => state.manager);

  return useQuery(
    [Key_universities, JSON.stringify(data)],
    () =>
      managerData && managerData?.idUser && managerData.isManager && managerData?.universities && managerData?.universities?.length > 0
        ? getUniversities(data).then(async (d) => {
            let filteredUniversities = d.items.filter((university: any) =>
              managerData.universities?.some((managerUniversity: any) => managerUniversity === university.id)
            );
                if(managerData.faculties && managerData.faculties.length>0){
                        const idsFaculties = managerData.faculties;
                        const universities = await getUniversitiesByIdFaculties({PageNumber:1, PageSize:100, IdsFaculties: idsFaculties});
                        filteredUniversities =Array.from(new Set([...filteredUniversities, ...universities.items]))
                    }
            return { ...d, items: filteredUniversities };
          })
        : getUniversities(data)
  );
};
